import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"
import { Modal } from "@bitcine/cs-theme"
import { DISMISS_BATCH_STATUS } from "@actions/preview/send"

const SendBatchStatus = ({ batchStatus, batchCreatedCount, batchTotalCount, onClose }) => (
  <Modal open onClose={onClose} title="Share by Email">
    <div>
      <div className='center py2'>
        {batchStatus === "sending" ? (
          <React.Fragment>
            <i className='material-icons spinning' style={{ fontSize: "5em" }}>sync</i>
            <h3 className='pb1'>Sending Preview Links...</h3>
            <p className='pb2 gray'>
              {batchTotalCount > 0 ? `${batchCreatedCount} of ${batchTotalCount} sent` : "Preparing..."}
            </p>
            {batchCreatedCount > 0 ? (
              <progress value={batchCreatedCount} max={batchTotalCount || 1} style={{ width: "200px" }} />
            ) : (
              <progress style={{ width: "200px" }} />
            )}
            <p className='mt2 gray' style={{ fontSize: "0.8em" }}>
              You can close this modal — emails will continue sending in the background and will appear in the screener summary.
            </p>
          </React.Fragment>
        ) : (
          <React.Fragment>
            <i className='material-icons red' style={{ fontSize: "5em" }}>error_outline</i>
            <h3 className='pb1'>Something Went Wrong</h3>
            <p className='pb1'>
              {batchCreatedCount > 0
                ? `${batchCreatedCount} of ${batchTotalCount} preview links were sent. The remaining ${batchTotalCount - batchCreatedCount} could not be processed due to an error.`
                : "Your preview links could not be sent. Please try again."}
            </p>
          </React.Fragment>
        )}
      </div>
    </div>
  </Modal>
)

SendBatchStatus.propTypes = {
  batchStatus: PropTypes.string.isRequired,
  batchCreatedCount: PropTypes.number.isRequired,
  batchTotalCount: PropTypes.number.isRequired,
  onClose: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
  batchStatus: state.preview.send.batchStatus,
  batchCreatedCount: state.preview.send.batchCreatedCount,
  batchTotalCount: state.preview.send.batchTotalCount
})

const mapDispatchToProps = dispatch => ({
  onClose: () => dispatch({ type: DISMISS_BATCH_STATUS })
})

export default connect(mapStateToProps, mapDispatchToProps)(SendBatchStatus)
